import * as React from 'react'
import { Box, Chip } from "@mui/material"
import {TooltipSeeker} from "@ui-seeker/core";


export default function statusColumn(isActual) {
	const name = isActual ? 'status' : 'statusList'
	const label = isActual ? 'Status' : 'Status List'
	const color = isActual ? 'statusColor' : 'statusColorList'
	return {
		name: name, label: label,
		options: {
			customBodyRowRenderLite: (value, rowData) => <TooltipSeeker
				title='Compares your lowest price with the lowest competitor price during the selected period.'
			>
				<Box sx={{ textAlign: 'center' }}>
               		<Chip label={value} sx={{ backgroundColor: rowData[color]}} />
            	</Box>
			</TooltipSeeker>
		}
	}
}